export default "__VITE_ASSET__CZpoDvNa__"